import { render, staticRenderFns } from "./AddNewEventTask.vue?vue&type=template&id=586b09ce&scoped=true"
import script from "./AddNewEventTask.vue?vue&type=script&lang=ts"
export * from "./AddNewEventTask.vue?vue&type=script&lang=ts"
import style0 from "./AddNewEventTask.vue?vue&type=style&index=0&id=586b09ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586b09ce",
  null
  
)

export default component.exports